/**
 * The duty enums, kept apart from the `Duty` model itself.
 *
 * `duties.ts` pulls the whole Vuex store in (its open/close getters read the
 * institution's opening hours), so anything importing the enums from there gets
 * the store as well. Pure calculation modules — the staffing overview, for one —
 * need the enum values without the store, and `duties.ts` re-exports both names
 * so existing imports keep working.
 */
export enum eTarget {
  SupervisionTime = 0,
  OtherTime = 1,
  PoolTime = 2,
  SchoolTime = 3,
  IncludedTime = 4
}

export enum eSource {
  SupervisionSchedule = 0,
  InstitutionCalendar = 1,
  Manual = 2,
  SchoolSchedule = 3
}
